import { format } from 'date-fns/format'
import capitalize from 'lodash/capitalize'

import { statesByValue } from 'constants/states'
import { License } from 'types/Provider'

type LicenseInfoProps = {
  label: string
  number: string
  expireDate: string
}

const LicenseInfo = ({ label, number, expireDate }: LicenseInfoProps) => {
  return (
    <div className="flex flex-col gap-2 typography-body-l">
      <p className="font-bold">{label}</p>
      <p className="font-medium tracking-[0.5px]">{number}</p>
      <p className="tracking-[0.5px]">Expires: {expireDate}</p>
    </div>
  )
}

const transformLicenseType = (type: string) => (type === 'hc' ? 'Health Coaching' : capitalize(type))

type LicensesListProps = {
  licenses: License[]
}

const LicensesList = ({ licenses }: LicensesListProps) => {
  return (
    <div className="flex flex-col gap-10">
      {licenses.map(({ state, type, number, expDate }) => {
        let label = `${transformLicenseType(type)} License`
        const printedState = statesByValue[state]
        if (printedState) {
          label = `${printedState} ${label}`
        }
        const formattedExpireDate = format(new Date(expDate), 'MMM dd, y')

        return <LicenseInfo key={`${label} ${number}`} label={label} number={number} expireDate={formattedExpireDate} />
      })}
    </div>
  )
}

export default LicensesList
